module.exports = __webpack_public_path__ + "img/logo-zwx.d1e9b71e.png";